<template>
  <v-container style="max-width: 500px; padding-top: 6rem" class="text-center">
    <v-icon color="success" size="80" class="mb-4">mdi-check-circle</v-icon>
    <h1 class="text-h4 font-weight-bold mb-2">Tak for dit køb!</h1>
    <p class="text-body-1 text-grey mb-8">
      Dit Premium-abonnement er nu aktivt. Du har fuld adgang til alle funktioner.
    </p>
    <v-btn color="primary" size="large" to="/dashboard">
      Gå til Dashboard
    </v-btn>
  </v-container>
</template>

<script setup>
import { onMounted } from "vue";
import { useAuthStore } from "../stores/auth";
import { useSubscriptionStore } from "../stores/subscription";

const auth = useAuthStore();
const sub = useSubscriptionStore();

onMounted(async () => {
  await auth.refreshUser();
  await sub.fetchStatus();
});
</script>
